const Loader = ({ show, message }) => {
  return (
    show && (
      <>
        <style>{`@keyframes spin { from { transform: rotate(0deg);} to { transform: rotate(360deg);} }`}</style>
        <div
          className="prep-overlay"
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(2px)",
            background: "rgba(0,0,0,0.35)",
            color: "#fff",
            borderRadius: "12px",
            textAlign: "center",
            padding: "1rem",
          }}
        >
          <div>
            <div
              style={{
                width: 32,
                height: 32,
                margin: "0 auto 8px",
                border: "3px solid rgba(255,255,255,0.4)",
                borderTopColor: "#fff",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
            <div style={{ fontWeight: 700, marginBottom: 4 }}>{message}</div>
          </div>
        </div>
      </>
    )
  );
};

export default Loader;
